export default __webpack_public_path__ + "static/media/BCH.dcaaa7f0.svg";